import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=be9311c2&"
import script from "./PersonModal.vue?vue&type=script&lang=js&"
export * from "./PersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9311c2')) {
      api.createRecord('be9311c2', component.options)
    } else {
      api.reload('be9311c2', component.options)
    }
    module.hot.accept("./PersonModal.vue?vue&type=template&id=be9311c2&", function () {
      api.rerender('be9311c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/Person/modules/PersonModal.vue"
export default component.exports